import React, { useEffect, useState } from "react";
import AdminLayout from "../../components/admin/AdminLayout";
import { Box, Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Loading from "../../components/Loading";

function AdminHistory() {
  const { t } = useTranslation();
  const { token } = useSelector((state) => state.admin);
  const [isLoading, setIsLoading] = useState(true);
  const [url, setURl] = useState("");

  useEffect(() => {
    let controller = new AbortController();
    (async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_KEY}api/v1/admin/allReportsPDF`,
          {
            headers: {
              Authorization: token,
            },
            signal: controller.signal,
          }
        );
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        setURl(url);
        setIsLoading(false);
      } catch (err) {
        console.error(err);
      }
    })();
    return () => controller?.abort();
  }, [token]);

  const handleDownloadFile = async () => {
    if (isLoading) {
      return;
    }
    try {
      const a = document.createElement("a");
      a.href = url;
      a.download = "all_reports_document.pdf";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <AdminLayout>
      {!isLoading ? (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "30px",
              marginTop: "20px",
            }}
          >
            <Typography sx={{ fontSize: "20px", fontWeight: "500" }}>
              {t("file_manager")}
            </Typography>
            <Button variant="contained" onClick={handleDownloadFile}>
              {t("download")}
            </Button>
          </Box>
          <iframe title={url} src={url} width="100%" height="500px" />
        </>
      ) : (
        <Loading />
      )}
    </AdminLayout>
  );
}

export default AdminHistory;
